(function () {
/*
 * -----------------------------------------------------------------------------
 * TABBED CONTENT
 * -----------------------------------------------------------------------------
 * @version 0.0.2
 * @overview Simple tabbed content.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("tabbed-content") === undefined) {
    class TabedContent extends HTMLElement {
        constructor(){
            super();
            this.tabs = this.querySelectorAll('[role="tab"]');
            if (!this.tabs.length) return;
            this.removeAttribute("hidden");
            this.tabFocus = 0;
            this.tabList = this.querySelector('[role="tablist"]');
            this.tabList.addEventListener("keydown", this.keyEvents.bind(this));
            this.tabs.forEach((tab)=>{
                tab.addEventListener("click", this.tabClick.bind(this));
            });
        }
        keyEvents(event) {
            if (event.keyCode != 39 && event.keyCode != 37) return;
            if (event.keyCode === 39) {
                this.tabFocus++;
                if (this.tabFocus >= this.tabs.length) this.tabFocus = 0;
            } else if (event.keyCode === 37) {
                this.tabFocus--;
                if (this.tabFocus < 0) this.tabFocus = this.tabs.length - 1;
            }
            this.activeTab = this.tabs[this.tabFocus];
            this.selectTab();
        }
        tabClick(event) {
            this.activeTab = event.target;
            this.selectTab();
        }
        selectTab() {
            this.querySelectorAll('[role="tab"]').forEach((item)=>{
                item.setAttribute("aria-selected", false);
                item.setAttribute("tabindex", -1);
            });
            this.activeTab.setAttribute("aria-selected", true);
            this.activeTab.setAttribute("tabindex", 0);
            this.activeTab.focus();
            this.querySelectorAll('[role="tabpanel"]').forEach((item)=>item.setAttribute("hidden", true));
            this.querySelector(`#${this.activeTab.getAttribute("aria-controls")}`).removeAttribute("hidden");
        }
    }
    customElements.define("tabbed-content", TabedContent);
}



})();
